import { createFileRoute } from '@tanstack/react-router'
import { LessonPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/de/kurse/$courseSlug/$lessonSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'lesson', locale: 'de', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { courseSlug, lessonSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <LessonPage courseSlug={courseSlug} lessonSlug={lessonSlug} />
    </CatalogProvider>
  )
}
